function substringAfter(value: string, marker: string): string {
  const index = value.indexOf(marker);
  return index < 0 ? value : value.slice(index + marker.length);
}

/**
 * Чтение параметров URL — перенос getParameter из ApiQuerys.kt:73-79.
 *
 * Особенность оригинала сохранена: адресная строка сначала декодируется целиком,
 * и только потом разбирается по «&». Поэтому значение параметра не декодируется
 * повторно, а «+» не превращается в пробел (ссылки в приложении собираются вручную).
 */
export function getParameter(
  name: string,
  search: string = window.location.search,
): string | undefined {
  const query = decodeURIComponent(substringAfter(search, '?'));
  const parts = query.split('&').filter((part) => part.split('=')[0] === name);
  if (parts.length === 0) return undefined;
  return parts
    .map((part) => part.split(`${name}=`)[1])
    .filter((value): value is string => value !== undefined)[0];
}

/** Параметры, которые читает фронтенд (см. TRANSFER-PLAN.md §2.3). */
export const URL_PARAMS = {
  firstQuery: 'q',
  viewQueryName: 'v',
  viewQueryWhere: 'w',
  endpointServiceUrl: 'b',
  rowFieldsValue: 'rFV',
  menuMode: 'm',
} as const;
